__turbopack_context__.v({
  "FeaturedProducts": "FeaturedProducts-module__0o9aNG__FeaturedProducts",
  "products": "FeaturedProducts-module__0o9aNG__products",
});
